import { render } from "./ArkModelSelect.vue?vue&type=template&id=4282770e&scoped=true"
import script from "./ArkModelSelect.vue?vue&type=script&lang=js"
export * from "./ArkModelSelect.vue?vue&type=script&lang=js"

import "./ArkModelSelect.vue?vue&type=style&index=0&id=4282770e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4282770e"]])

export default __exports__